import { ALLIANCE_APPS } from './alliance-apps';

/**
 * This repo's app: the per-app values the shared Alliance components read.
 */
export const CURRENT_APP = ALLIANCE_APPS.leads;

/**
 * Display fonts. Roboto is used everywhere else. The nav font applies to the
 * top-nav links and the wordmark; the title font to Sign In and System
 * Screen headings.
 */
export const CURRENT_APP_FONTS = {
  nav: null,
  title: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    textTransform: 'none',
  },
} as const;
